var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "email-setup-provider-warning-modal",
    attrs: {
      visible: _vm.showModal,
      title: _vm.$t.__("email.SetUpProviderModal.title"),
      primaryAction: _vm.primaryAction,
      closeOnClickOverlay: false
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "email-setup-provider-warning-modal__content" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "email-setup-provider-warning-modal__illustration"
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "/ressources/logged/img/illustrations/disconnected.svg"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "email-setup-provider-warning-modal__informations"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-large-bold" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t.__(
                                "email.SetUpProviderModal.informations.title"
                              )
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "typographies-paragraph-medium-regular",
                      domProps: { innerHTML: _vm._s(_vm.subtitle) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "email-setup-provider-warning-modal__benefits"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "email-setup-provider-warning-modal__benefits-illustration"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              "/ressources/logged/img/illustrations/provider-email.svg"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass:
                          "email-setup-provider-warning-modal__benefits-list"
                      },
                      _vm._l(_vm.benefits, function(benefit, index) {
                        return _c("li", {
                          key: index,
                          staticClass:
                            "email-setup-provider-warning-modal__benefits-list-item typographies-paragraph-medium-regular",
                          domProps: { innerHTML: _vm._s(benefit) }
                        })
                      }),
                      0
                    )
                  ]
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }